import React from "react";
import SectionSociete from "./SectionSociete";
import SectionDemandeur from "./SectionDemandeur";
import SectionComplementaires from "./SectionComplementaires";

interface IProps {
  isPaysLoading: boolean;
  pays: any;
  isFranceOrAssimile: boolean;
  isSecteurActivitesLoading: boolean;
  secteurActivites: any;
  isFonctionsLoading: boolean;
  fonctions: any;
  watchedMessage: string;
  watchedAcceptationCGU: boolean;
  sirenApiError: string | null;
  motifRefus: string | null;
  handleOpenModalConvention: (e: React.MouseEvent<Element, MouseEvent>) => void;
  handleCheckboxClick: (e: React.MouseEvent<HTMLInputElement, MouseEvent>) => void;
  onRetour: () => void;
}

const CpntInscriptionForm: React.FC<IProps> = ({
  isPaysLoading,
  pays,
  isFranceOrAssimile,
  isSecteurActivitesLoading,
  secteurActivites,
  isFonctionsLoading,
  fonctions,
  watchedMessage,
  watchedAcceptationCGU,
  sirenApiError,
  motifRefus,
  handleOpenModalConvention,
  handleCheckboxClick,
  onRetour,
}) => {
  return (
    <>
      {motifRefus && (
        <div className="alert alert-danger" role="alert" style={{ marginTop: "20px" }}>
          <strong>Demande refusée :</strong> {motifRefus}
        </div>
      )}

      <SectionSociete
        isPaysLoading={isPaysLoading}
        pays={pays}
        isFranceOrAssimile={isFranceOrAssimile}
      />

      <SectionDemandeur 
        isFonctionsLoading={isFonctionsLoading}
        fonctions={fonctions}
      />

      <SectionComplementaires
        isSecteurActivitesLoading={isSecteurActivitesLoading}
        secteurActivites={secteurActivites}
        watchedMessage={watchedMessage}
        watchedAcceptationCGU={watchedAcceptationCGU}
        handleOpenModalConvention={handleOpenModalConvention}
        handleCheckboxClick={handleCheckboxClick}
        sirenApiError={sirenApiError}
        onRetour={onRetour}
      />
    </>
  );
};

export default CpntInscriptionForm;
